import React, { useState, useEffect } from "react";

/// Components
import { Stage, Layer, Image, Group } from "react-konva";
import TransformableText from "./TransformableText";
import TransformableImage from "./TransformableImage";
import TransformableLogoImage from "./TransformableLogoImage";
const CanvasStage = ({
  frameOne,
  selectedFrame,
  stageRef,
  userName,
  guildName,
  frameImg,
  whiteImg,
  image,
  checked,
  checkedGuild,
  bgColor,
  bgColorGuild,
  fontFamily,
  fontColor,
  fontColorGuild,
  fontFamilyGuild,
  alignment,
  width,
  height,
  imageLogo,
  guildSeconedName,
  birthdayWish,
}) => {
  const frameWidth = 375;
  const frameHeight = 460;
  const groupDimensions = {
    height: frameHeight,
    width: frameWidth,
  };
  const groupHeight = groupDimensions.height;
  const aspectRatio = width / height;
  const imageRenderWidth = aspectRatio * groupDimensions.height;
  const imageRenderHeight = groupDimensions.height;
  const [imagePositionX, setimagePositionX] = useState(-100);
  const imagePositionY = 22;
  const rect = [
    {
      x: 50,
      y: 50,
      id: "rect1",
    },
    {
      x: 100,
      y: 100,
      id: "rect2",
    },
  ];

  const renderImg = [
    {
      x: imagePositionX,
      y: imagePositionY,
      id: "renderImg1",
    },
  ];

  const [tranImg, setTranImg] = useState(renderImg);
  const [selectedId1, selectShape1] = useState(null);
  const [rectangles, setRectangles] = useState(rect);
  const [selectedId, selectShape] = useState(null);

  const checkDeselect = () => {
    selectShape1(null);
    selectShape(null);
  };

  useEffect(() => {
    if (selectedFrame === frameOne) {
      setimagePositionX(0);
    } else {
      setimagePositionX(55);
    }
  }, [selectedFrame]);
  return (
    <Stage
      ref={stageRef}
      width={frameWidth}
      height={frameHeight}
      x={0}
      style={{ margin: "auto", background: "#fff" }}
    >
      <Layer>
        <Image
          image={whiteImg}
          width={frameWidth}
          height={frameHeight}
          style={{ zIndex: "99", position: "absolute" }}
          onMouseDown={checkDeselect}
          onTouchStart={checkDeselect}
          listening={false}
        />
        <Group
          clipX={imagePositionX}
          clipY={imagePositionY}
          clipWidth={groupDimensions.width}
          clipHeight={groupHeight}
        >
          <TransformableImage
            frameOne={frameOne}
            selectedFrame={selectedFrame}
            image={image}
            imageWidth={width}
            imageHeight={height}
            onMouseDown={checkDeselect}
            onTouchStart={checkDeselect}
            isSelected={renderImg[0].id === selectedId1}
            onSelect={() => {
              selectShape1(renderImg[0].id);
            }}
            onChange={(newAttrs) => {
              const imgs = tranImg.slice();
              imgs[0] = newAttrs;
              setTranImg(imgs);
            }}
          />
          <div style={{ borderRadius: "50% !important" }}>
            {console.log("imageLogo--------->", imageLogo)}
            <TransformableLogoImage
              frameOne={frameOne}
              image={imageLogo}
              imageWidth={width}
              imageHeight={height}
              onMouseDown={checkDeselect}
              onTouchStart={checkDeselect}
              isSelected={renderImg[0].id === selectedId1}
              onSelect={() => {
                selectShape1(renderImg[0].id);
              }}
              onChange={(newAttrs) => {
                const imgs = tranImg.slice();
                imgs[0] = newAttrs;
                setTranImg(imgs);
              }}
              selectedFrame={selectedFrame}
            />
          </div>
        </Group>

        <Image
          image={frameImg}
          width={frameWidth}
          height={frameHeight}
          style={{ zIndex: "100", position: "absolute" }}
          onMouseDown={checkDeselect}
          onTouchStart={checkDeselect}
          listening={false}
        />
        {checked && (
          <>
            <TransformableText
              color={"#FEFEFE"}
              x={72.5}
              y={212}
              frameOne={frameOne}
              selectedFrame={selectedFrame}
              name={userName}
              colour={bgColor}
              fontFamily={fontFamily}
              alignment={alignment}
              fontColor={fontColor}
              onMouseDown={checkDeselect}
              onTouchStart={checkDeselect}
              fontStyle="bold"
              fontSize={8.738}
              shapeProps={rect[0]}
              isSelected={rect[0].id === selectedId}
              onSelect={() => {
                selectShape(rect[0].id);
              }}
              onChange={(newAttrs) => {
                const rects = rectangles.slice();
                rects[0] = newAttrs;
                setRectangles(rects);
              }}
              textTransform="uppercase"
            />

            <TransformableText
              color={"#265BA1"}
              x={73}
              y={243}
              frameOne={frameOne}
              selectedFrame={selectedFrame}
              name={guildName}
              colour={bgColor}
              fontFamily={fontFamily}
              alignment={alignment}
              fontColor={fontColor}
              onMouseDown={checkDeselect}
              onTouchStart={checkDeselect}
              fontStyle="bold"
              fontSize={10}
              shapeProps={rect[0]}
              isSelected={rect[0].id === selectedId}
              onSelect={() => {
                selectShape(rect[0].id);
              }}
              onChange={(newAttrs) => {
                const rects = rectangles.slice();
                rects[0] = newAttrs;
                setRectangles(rects);
              }}
              textTransform="uppercase"
            />
            <div style={{backgroundColor:"red",border:"1px solid red"}}>
            <TransformableText
              color={"#FFFFFF"}
              x={41}
              y={263}
              frameOne={frameOne}
              selectedFrame={selectedFrame}
              name={guildSeconedName}
              colour={bgColor}
              fontFamily={"Outfit"}
              alignment={alignment}
              fontColor={fontColor}
              onMouseDown={checkDeselect}
              onTouchStart={checkDeselect}
              fontStyle="bold"
              fontSize={22}
              shapeProps={rect[0]}
              isSelected={rect[0].id === selectedId}
              onSelect={() => {
                selectShape(rect[0].id);
              }}
              onChange={(newAttrs) => {
                const rects = rectangles.slice();
                rects[0] = newAttrs;
                setRectangles(rects);
              }}
              textTransform="capitalize"
            />
            </div>
           <TransformableText
              color={"#FFFFFF"}
              x={-80}  // ✅ FIXED - centered with padding
              y={250}   // Adjusted for better spacing
              frameOne={frameOne}
              selectedFrame={selectedFrame}
              name={birthdayWish}
              colour={bgColor}
              fontFamily={fontFamily}
              alignment={"center"}  // ✅ FIXED - center alignment
              fontColor={fontColor}
              onMouseDown={checkDeselect}
              onTouchStart={checkDeselect}
              fontStyle="normal"  // Changed from "regular" to "normal"
              fontSize={10}       // Slightly larger for readability
              shapeProps={rect[1]}
              isSelected={rect[1].id === selectedId}
              onSelect={() => {
                selectShape(rect[1].id);
              }}
              onChange={(newAttrs) => {
                const rects = rectangles.slice();
                rects[1] = newAttrs;
                setRectangles(rects);
              }}
              width={340}
              height={150}
              textTransform="none"
            />
          </>
        )}
      </Layer>
    </Stage>
  );
};

export default CanvasStage;
